import classNames from "classnames";
import { lazy, Suspense } from "react";

import { useTypedSelector } from "../../../store/reducers/use-typed-selector";
import { TemplateNames } from "../../../types/template-layouts";
const EventChatMain = lazy(() => import("./event-chat-main"));

interface IPreviewEventChatMain {
	chatTopPosition?: number;
	isSessionPreview?: boolean;
}

const PreviewEventChatMain: React.FC<IPreviewEventChatMain> = ({ chatTopPosition = 0, isSessionPreview = false }) => {

	const workingEvent = useTypedSelector(state => state.CreateEventReducer.workingEvent);
	const editorSize = useTypedSelector(state => state.CreateEventReducer.editorSize);

	const eventChatEnabled = workingEvent?.social_settings?.messaging;

	if (!workingEvent || !eventChatEnabled) return null;
	return (
		<div
			className={classNames('event-chat-preview-container', editorSize, {
				'session-preview': !!isSessionPreview
			})}
			style={{ top: `calc(100% + ${chatTopPosition}px)` }}
		>
			<Suspense fallback="">
				<EventChatMain
					template={workingEvent?.template.name ?? TemplateNames.Apollo}
					eventBundle={workingEvent}
					previewMode
					chatTopPosition={chatTopPosition}
				/>
			</Suspense>
		</div>
	);
};

export default PreviewEventChatMain;
